import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Division() {
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  const [divisions, setDivisions] = useState({});

  const location = useLocation();

  const memberId = location.pathname.split('/')[2];

  useEffect(() => {
    const fetchDivisions = async () => {
      try {
        const res = await axios.get(
          `https://databasebackend.ecz.co.zw/divisions/${memberId}`
        );
        setDivisions(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchDivisions();
  }, [memberId]);

  return (
    <div className="member">
      <div className="memberTitleContainer">
        <h1 className="memberTitle">Division Details</h1>
        <Link to={'/edit-division/' + memberId}>
          <button className="memberAddButton">Edit</button>
        </Link>
      </div>
      <div className="memberContainer">
        <div className="memberShow">
          <div className="memberShowBottom">
            <div className="memberShowInfo">
              <span className="memberShowInfoLabel">Name:</span>{' '}
              <span className="memberShowInfoTitle">{divisions.division}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
